/**
 * Performance PDP product recommendation — add selected product to cart (no nested form).
 */
(function () {
  function spinnerHtml() {
    return '<div class="spinner-border spinner-border-sm" role="status"><span class="visually-hidden">Loading</span></div>';
  }

  function setBtnLabel(btn, html) {
    if (btn) btn.innerHTML = html;
  }

  async function addRecommendationToCart(card, btn) {
    var variantId = parseInt(card.dataset.variantId, 10);
    var qty = parseInt(card.dataset.quantity, 10) || 1;
    if (!variantId) return;

    var defaultLabel = btn.dataset.textAddToCart || "+ Add";
    btn.disabled = true;
    btn.classList.add("loading");
    setBtnLabel(btn, spinnerHtml());

    try {
      var response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: qty }),
      });

      if (!response.ok) {
        var err = await response.json();
        throw new Error(err.description || err.message || "Could not add to cart");
      }

      if (window.refreshCartContents) {
        window.refreshCartContents(response);
      }

      var added =
        (window.theme && window.theme.product && window.theme.product.addedToCart) ||
        "Added";
      setBtnLabel(btn, added);

      setTimeout(function () {
        btn.disabled = false;
        btn.classList.remove("loading");
        setBtnLabel(btn, defaultLabel);
      }, 2000);

      var offcanvas = document.querySelector("#offcanvas-cart");
      if (offcanvas && window.bootstrap && window.bootstrap.Offcanvas) {
        window.bootstrap.Offcanvas.getOrCreateInstance(offcanvas).show();
      }
    } catch (e) {
      btn.disabled = false;
      btn.classList.remove("loading");
      setBtnLabel(btn, defaultLabel);
      alert(e.message || "Something went wrong. Please try again.");
    }
  }

  function onClick(e) {
    var btn = e.target.closest("[data-perf-product-recommendation-atc]");
    if (!btn) return;
    var card = btn.closest("[data-perf-product-recommendation]");
    if (!card) return;
    e.preventDefault();
    addRecommendationToCart(card, btn);
  }

  function bind(root) {
    root = root || document;
    root.addEventListener("click", onClick);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      bind(document);
    });
  } else {
    bind(document);
  }
})();
